import { useTranslation } from "react-i18next";
import { Link, LinkType } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import Parameter from "~/common/components/Parameter";

export const MyAccountParts = {
  ChangeEmailLink: ({ href }: { href?: string }) => {
    const { t } = useTranslation();
    if (!href) {
      return null;
    }

    return (
      <Link variant={LinkType.PRIMARY} href={href} target={"_blank"} iconBefore={<Icon type={IconType.OpenInNew} />}>
        {t("myAccount.changeEmail")}
      </Link>
    );
  },
  EmailParameter: ({ email }: { email: string }) => {
    const { t } = useTranslation();
    return (
      <Parameter label={t("page.completeRegistration.email")} value={<div className="title-medium">{email}</div>} />
    );
  },
};
